import { URI } from '@/config/config'

export default async ({ rootState }, { query }) => {
  const opts = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken
    },
    body: JSON.stringify(query)
  }

  try {
    const resultList = await fetch(`${URI}reports/parked-notified`, opts)
    if (!resultList.ok) {
      return Promise.reject()
    }
    const jsonResult = await resultList.json()

    return jsonResult.notifiedList
  } catch (error) {
    return Promise.reject(error)
  }
}